/**
 * Shared constants for the public site so copy like the contact email or
 * anchor targets aren't duplicated across landing page sections.
 */
export const SITE = {
  productName: "Callback",
  demoContactEmail: "hello@callback.example",
  signupHref: "/signup",
  demoHref: "#contact",
} as const;
